import { render } from "./CompaniaGuardias.vue?vue&type=template&id=32d16d12"
import script from "./CompaniaGuardias.vue?vue&type=script&lang=js"
export * from "./CompaniaGuardias.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__